export const DATE_FORMAT = "MM/DD/YYYY";
export const DOLLOR_SIGN = "$";
export const COMA_SYMBOL = ",";
export const COLORS_DEFAULT = '211, 211, 211';
export const COLORS_DEFAULT_BLACK = '60, 60, 60';

export const COLORS = [
  "252, 140, 68",
  "252, 204, 156",
  "92, 212, 180",
  "4, 180, 204",
  "4, 76, 140",
  "241, 225, 91",
  "232, 168, 56"
];


